import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextTitle3 } from '@cbhq/cds-web/typography';

import { useAppState } from ':cloud/contexts/AppStateContext';
import { TransactionsReportingSection } from ':cloud/widgets/onramp/TransactionsReportingSection';
import { FULL_PAGE_MAX_WIDTH } from ':cloud/widgets/product/constants';

export function OnrampLogs() {
  const { selectedProject } = useAppState();
  return (
    <VStack maxWidth={FULL_PAGE_MAX_WIDTH} spacing={10} gap={5} borderedBottom>
      <HStack alignItems="center" gap={2}>
        <TextTitle3 as="h1">Logs</TextTitle3>
      </HStack>
      {selectedProject && <TransactionsReportingSection project={selectedProject} />}
    </VStack>
  );
}
